import { render, staticRenderFns } from "./WidgetBase.vue?vue&type=template&id=963ba350&scoped=true"
import script from "./WidgetBase.vue?vue&type=script&lang=js"
export * from "./WidgetBase.vue?vue&type=script&lang=js"
import style0 from "./WidgetBase.vue?vue&type=style&index=0&id=963ba350&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963ba350",
  null
  
)

export default component.exports